<template>
  <v-container>
    <v-skeleton-loader v-if="$apollo.loading || !article" type="card-heading, list-item, image@2, list-item-three-line@5" />
    <v-card v-else class="pa-5">
      <h3 class="text-h3 mb-10">
        {{ article.name }}
      </h3>
      <div>
        <v-chip>ID: {{ article.id }}</v-chip>
        <v-chip>Статус: {{ article.status }}</v-chip>
        <v-chip>Категория: {{ article.category.name }}</v-chip>
        <v-chip>Дата создания: {{ formatTimestamp(article.createdAt) }}</v-chip>
        <v-chip>Дата публикации: {{ formatTimestamp(article.publishAt) }}</v-chip>
      </div>
      <v-divider class="my-7" />
      <template v-for="image in images">
        <p :key="image.url" class="text-h5">
          {{ image.title }}:
        </p>
        <v-img :key="image.url" :src="image.url" :alt="image.alt" max-height="500" max-width="600" />
      </template>
      <p class="text-h5 mt-5">
        Краткое описание:
      </p>
      <div class="px-5" v-html="article.shortDescription" />
      <p class="text-h5 mt-5">
        Контент:
      </p>
      <div class="px-5" v-html="article.fullDescription" />
    </v-card>
  </v-container>
</template>

<script>
import { article } from '@/graphql/articles'
import { isEmpty } from 'lodash-es'

export default {
  name: 'Article',
  layout: 'dashboard',
  apollo: {
    article: {
      query: article,
      variables () {
        return {
          id: Number(this.$route.params.id)
        }
      }
    }
  },
  computed: {
    images () {
      return isEmpty(this.article)
        ? []
        : [
            ['Превью', this?.article?.image ?? []],
            ['Изображение', this?.article?.previewImage ?? []]
          ]
              .map(([title, image]) => ({ title, url: image?.file?.url, alt: image?.alt }))
    }
  },
  methods: {
    formatTimestamp (timestamp) {
      return new Date(timestamp * 1000).toLocaleString('ru-RU')
    }
  }
}
</script>

<style scoped>

</style>
